import { SvgTypesProps } from '@/shared/types/SvgTypes';

export function IconEdit({
  fill = 'var(--color-cream)',
  width = 18,
  height = 18,
}: SvgTypesProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.13288 14.9468L16.6993 4.38041C17.1002 3.9795 17.1002 3.32951 16.6993 2.92861L15.0714 1.30068C14.6705 0.899774 14.0205 0.899775 13.6196 1.30068L3.05315 11.8671M6.13288 14.9468L5.50843 15.5713C5.2453 15.8344 4.91561 16.0211 4.55459 16.1114L1 17L1.88865 13.4454C1.9789 13.0844 2.16557 12.7547 2.4287 12.4916L3.05315 11.8671M6.13288 14.9468L5.71844 14.118C5.3211 13.3233 4.67672 12.6789 3.88204 12.2816L3.05315 11.8671" stroke={fill} strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  );
}
